import { getUserInfo, logout }from "@/api/user"
import { getActiveDetail } from "@/api/home.js";
import { clearToken } from "@/utils/token"
import router from "@/router";
import Vue from "vue";
export default {
  state: {
    isLogin: false,
    userInfo: null,
    roles: [],
    dsUser: null, // 扩展用户信息
    activeInfo: {}, // 活动信息
    reload: false, // 刷新页面
  },
  mutations: {
    SET_INFO(state, userInfo) {
      state.userInfo = userInfo.user,
      state.roles = userInfo.roles,
      state.dsUser = userInfo.dsUser,
      state.isLogin = true
    },
    SET_ACTIVE_INFO(state, activeInfo) {
      state.activeInfo = activeInfo
    },
    LOGIN_OUT(state) {  
      state.userInfo = null;
      state.dsUser = null;
      state.roles = [];
      state.isLogin = false
    },
    RELOAD_PAGE(state, flag) {
      if(flag) {
        state.reload = false
      }else {
        state.reload = true
        Vue.nextTick(() => {
          state.reload = false
        })
      }
    }
  },
   actions: {
    async getUserInfo({ commit }) {
     return new Promise((resolve, reject) => {
      getUserInfo().then(res => {
        commit('SET_INFO', res)
        resolve(true)
      }).catch(() => {
        resolve(false)
      })
     }) 
    },
    // 退出登录
    async logout({ commit }) {
      return new Promise((resolve, reject) => {
       logout().then(res => {
         clearToken()
         commit('LOGIN_OUT')
         router.replace("/");
         resolve(true)
       }).catch(() => {
         resolve(false)
       })
      }) 
     },
    //  获取活动信息
     async getActiveDetail({ commit }) {
      return new Promise((resolve, reject) => {
        getActiveDetail().then(res => {
         commit('SET_ACTIVE_INFO', res.data)
         resolve(true)
       }).catch(() => {
         resolve(false)
       })
      }) 
     },
  }
}